module.exports = __webpack_public_path__ + "img/10.147a8924.svg";